/* ============================================================
   tio-pdp.js — pagina de producto.

   Un solo estado (variante + cantidad) compartido por la pagina y el
   bottom-sheet: elegir un formato arriba lo refleja abajo y al reves.

   CADENA F3 (MIGRATION 8.1) en los dos CTAs, en este orden:
     1. POST /cart/add.js PRIMERO
     2. feedback "Agregado" SOLO con respuesta OK
     3. vuelo como DECORACION, con guard teFlySafe
   El contador usa el item_count REAL de /cart.js.

   El <form> del servidor es real: sin JS el add funciona con recarga.
   Aca solo se intercepta para no salir de la pagina.

   Doctrina 8.1: listeners DELEGADOS en document.
   ============================================================ */
(function () {
  'use strict';

  var raiz = document.querySelector('[data-tio-pdp]');
  if (!raiz) return;

  var estado = { variantId: null, precio: 0, ml: '', qty: 1 };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------------- Formato de precio ----------------
     Se reusa el string que Liquid ya formateo para cada variante: asi el
     JS no re-implementa el formato de moneda de la tienda. Para el total
     (precio x cantidad) se calcula sobre los centavos y se re-arma con
     el mismo separador que uso Liquid. */
  var molde = null;

  function formatear(centavos) {
    if (!molde) return '';
    var pesos = Math.round(centavos / 100);
    var partes = String(pesos).split('').reverse();
    var out = [];
    for (var i = 0; i < partes.length; i++) {
      if (i > 0 && i % 3 === 0) out.push(molde.separador);
      out.push(partes[i]);
    }
    return molde.antes + out.reverse().join('') + molde.despues;
  }

  function deducirMolde(texto, centavos) {
    var pesos = String(Math.round(centavos / 100));
    if (pesos.length <= 3) return null;
    var sep = texto.replace(/[\d\s]/g, '').replace(/[^.,]/g, '');
    var separador = sep.indexOf('.') >= 0 ? '.' : (sep.indexOf(',') >= 0 ? ',' : '');
    var soloNum = texto.replace(/[^\d.,]/g, '');
    var idx = texto.indexOf(soloNum);
    return { separador: separador, antes: texto.slice(0, idx), despues: texto.slice(idx + soloNum.length) };
  }

  /* ---------------- Sincronizar estado -> DOM ---------------- */
  function pintar() {
    $$('[data-tio-pdp-fmt]').forEach(function (b) {
      var activo = b.getAttribute('data-variant-id') === String(estado.variantId);
      b.classList.toggle('is-active', activo);
      b.setAttribute('aria-pressed', activo ? 'true' : 'false');
    });

    var precioTxt = formatear(estado.precio) || '';
    var elPrecio = $('[data-tio-pdp-precio]');
    if (elPrecio && precioTxt) elPrecio.textContent = precioTxt;

    var pillPr = $('[data-tio-pdp-pill-precio]');
    if (pillPr && precioTxt) pillPr.textContent = precioTxt;
    var pillMl = $('[data-tio-pdp-pill-ml]');
    if (pillMl) pillMl.textContent = estado.ml;

    var input = $('[data-tio-pdp-variante]');
    if (input) input.value = estado.variantId;

    $$('[data-tio-pdp-qty-n]').forEach(function (n) { n.textContent = estado.qty; });
    var qi = $('[data-tio-pdp-qty-input]');
    if (qi) qi.value = estado.qty;
    $$('[data-tio-pdp-qty="-1"]').forEach(function (b) { b.disabled = estado.qty <= 1; });

    var total = $('[data-tio-pdp-total]');
    if (total) {
      var t = formatear(estado.precio * estado.qty);
      if (t) total.textContent = t;
    }
    var totalLbl = $('[data-tio-pdp-total-lbl]');
    if (totalLbl) totalLbl.textContent = estado.qty > 1 ? 'Total · ' + estado.qty + ' un.' : 'Total';
  }

  /* ---------------- Init desde el markup del servidor ---------------- */
  (function iniciar() {
    var activo = $('[data-tio-pdp-fmt].is-active') || $('[data-tio-pdp-fmt]:not([disabled])');
    if (!activo) return;
    estado.variantId = activo.getAttribute('data-variant-id');
    estado.precio = parseInt(activo.getAttribute('data-precio-centavos'), 10) || 0;
    estado.ml = activo.getAttribute('data-ml') || '';
    molde = deducirMolde(activo.getAttribute('data-precio') || '', estado.precio);
  })();

  /* ---------------- Listeners delegados ---------------- */
  document.addEventListener('click', function (e) {
    /* Elegir formato — se refleja en la pagina Y en el sheet */
    var fmt = e.target.closest('[data-tio-pdp-fmt]');
    if (fmt && !fmt.disabled) {
      estado.variantId = fmt.getAttribute('data-variant-id');
      estado.precio = parseInt(fmt.getAttribute('data-precio-centavos'), 10) || 0;
      estado.ml = fmt.getAttribute('data-ml') || '';
      if (!molde) molde = deducirMolde(fmt.getAttribute('data-precio') || '', estado.precio);
      pintar();
      return;
    }

    /* Cantidad */
    var qty = e.target.closest('[data-tio-pdp-qty]');
    if (qty) {
      var d = parseInt(qty.getAttribute('data-tio-pdp-qty'), 10);
      estado.qty = Math.max(1, Math.min(99, estado.qty + d));
      pintar();
      return;
    }

    /* Popover "¿cuanto rinde?" */
    var ayuda = e.target.closest('[data-tio-pdp-ayuda]');
    if (ayuda) {
      var guia = document.getElementById(ayuda.getAttribute('aria-controls'));
      var abierto = ayuda.getAttribute('aria-expanded') === 'true';
      ayuda.setAttribute('aria-expanded', abierto ? 'false' : 'true');
      ayuda.classList.toggle('is-open', !abierto);
      if (guia) guia.classList.toggle('is-open', !abierto);
      return;
    }
    if (e.target.closest('[data-tio-pdp-ayuda-cerrar]')) {
      $$('[data-tio-pdp-ayuda]').forEach(function (b) {
        b.setAttribute('aria-expanded', 'false');
        b.classList.remove('is-open');
        var g = document.getElementById(b.getAttribute('aria-controls'));
        if (g) g.classList.remove('is-open');
      });
      return;
    }

    /* Galeria */
    var dot = e.target.closest('[data-tio-pdp-dot]');
    if (dot) { irAFoto(parseInt(dot.getAttribute('data-tio-pdp-dot'), 10)); return; }
    if (e.target.closest('[data-tio-pdp-prev]')) { irAFoto(fotoActual() - 1); return; }
    if (e.target.closest('[data-tio-pdp-next]')) { irAFoto(fotoActual() + 1); return; }

    /* Bottom-sheet */
    if (e.target.closest('[data-tio-pdp-abrir-sheet]')) { abrirSheet(); return; }
    if (e.target.closest('[data-tio-pdp-cerrar-sheet]')) { cerrarSheet(); return; }
    var ov = $('[data-tio-pdp-sheet]');
    if (ov && e.target === ov) { cerrarSheet(); return; }

    /* CTA del sheet (el de la pagina va por submit del form) */
    var addSheet = e.target.closest('[data-tio-pdp-add-sheet]');
    if (addSheet && !addSheet.disabled) { agregar(addSheet, true); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') cerrarSheet();
  });

  /* ---------------- Galeria ---------------- */
  function pista() { return $('[data-tio-pdp-track]'); }

  function fotoActual() {
    var t = pista();
    if (!t || !t.clientWidth) return 0;
    return Math.round(t.scrollLeft / t.clientWidth);
  }

  function irAFoto(i) {
    var t = pista();
    if (!t) return;
    var n = Math.max(0, Math.min(t.children.length - 1, i));
    t.scrollTo({ left: n * t.clientWidth, behavior: 'smooth' });
    marcarFoto(n);
  }

  function marcarFoto(n) {
    $$('[data-tio-pdp-dot]').forEach(function (d, i) { d.classList.toggle('is-active', i === n); });
    var prev = $('[data-tio-pdp-prev]');
    var next = $('[data-tio-pdp-next]');
    var t = pista();
    if (prev) prev.disabled = n === 0;
    if (next && t) next.disabled = n >= t.children.length - 1;
  }

  if (pista()) {
    pista().addEventListener('scroll', function () { marcarFoto(fotoActual()); }, { passive: true });
  }

  /* ---------------- Bottom-sheet ---------------- */
  function bloquearScroll(si) {
    if (si) {
      var comp = window.innerWidth - document.documentElement.clientWidth;
      document.body.style.overflow = 'hidden';
      if (comp > 0) document.body.style.paddingRight = comp + 'px';
    } else {
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }

  function abrirSheet() {
    var ov = $('[data-tio-pdp-sheet]');
    if (!ov) return;
    ov.classList.add('is-active');
    ov.setAttribute('aria-hidden', 'false');
    bloquearScroll(true);
    evaluarPill();   /* baja la pildora y hace que el FAB ceda paso */
  }

  function cerrarSheet() {
    var ov = $('[data-tio-pdp-sheet]');
    if (!ov || !ov.classList.contains('is-active')) return;
    ov.classList.remove('is-active');
    ov.setAttribute('aria-hidden', 'true');
    bloquearScroll(false);
    evaluarPill();
  }

  /* ---------------- Pildora flotante ----------------
     IntersectionObserver sobre el CTA original: sin listeners de scroll.
     Solo se muestra si el CTA salio POR ARRIBA. */
  var ancla = $('[data-tio-pdp-cta-ancla]');
  var pillVisible = false;

  /* El FAB de WhatsApp CEDE PASO a la pildora: los dos viven abajo a la
     derecha y se pisarian. Se oculta mientras la pildora esta arriba O el
     sheet abierto, y vuelve solo al desaparecer ambos. Debounce de 120ms
     (mismo valor del diseno) para que no parpadee en el cruce. */
  var relojWa = null;

  function cederPasoWa(ocultar) {
    clearTimeout(relojWa);
    relojWa = setTimeout(function () {
      var wa = document.querySelector('[data-tio-wa]');
      if (!wa) return;
      wa.classList.toggle('is-hidden', ocultar);
      wa.setAttribute('aria-hidden', ocultar ? 'true' : 'false');
      /* el FAB en si, no la X del popover */
      var boton = wa.querySelector('[data-tio-wa-toggle]');
      if (boton) boton.tabIndex = ocultar ? -1 : 0;
      /* si se oculta con el popover abierto, se cierra: no puede quedar
         un panel flotando sin su boton */
      if (ocultar) wa.classList.remove('open');
    }, 120);
  }

  function evaluarPill() {
    var pill = $('[data-tio-pdp-pill]');
    var ov = $('[data-tio-pdp-sheet]');
    if (!pill) return;
    var sheetAbierto = ov && ov.classList.contains('is-active');
    var mostrar = pillVisible && !sheetAbierto;
    pill.classList.toggle('is-on', mostrar);
    pill.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
    var cta = $('[data-tio-pdp-abrir-sheet]');
    if (cta) cta.tabIndex = mostrar ? 0 : -1;

    cederPasoWa(pillVisible || sheetAbierto);
  }

  /* El rootMargin extiende la raiz MUY abajo a proposito.
     Sin eso el ancla queda "fuera de vista" en DOS situaciones distintas
     — todavia no se llego a ella, y ya se paso — y el observer no puede
     distinguirlas: al volver arriba rapido no hay cruce que reportar y la
     pildora se queda pegada. Verificado en el navegador: bajaba bien pero
     no volvia nunca.
     Estirando la raiz hacia abajo, el ancla esta "intersectando" siempre
     que este a la altura del borde superior o mas abajo, y deja de estarlo
     SOLO al pasarse por arriba. Queda una unica frontera, que siempre
     genera callback en ambos sentidos.
     El -72px es el de la spec: bajo la pildora glass del header ya cuenta
     como no visible. Sigue sin haber un solo listener de scroll. */
  if (ancla && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entradas) {
      pillVisible = !entradas[0].isIntersecting;
      evaluarPill();
    }, { rootMargin: '-72px 0px 100000px 0px', threshold: 0 }).observe(ancla);
  }

  /* ---------------- CADENA F3 ----------------

     ⚠️ CORREGIDO 28-jul-2026 (reporte del dueno: "responde muy lenta la
     animacion... o simplemente al segundo intento ya no ejecuta. En el dibujo
     original aunque lo aprete 100 veces responde como corresponde").

     Eran TRES bugs encadenados, todos mios, ninguno del diseno:

     1. EL BOTON QUEDABA MUERTO 1,6 s. Ponia `boton.disabled = true` al
        empezar y solo lo soltaba en el .finally(), DESPUES del timeout visual
        de 1600ms. O sea: durante 1,6 segundos el segundo click no hacia
        absolutamente nada. Eso es exactamente "al segundo intento ya no
        ejecuta". El prototipo no deshabilita nunca (su `disabled` es el de
        AGOTADO, no un estado de ocupado): por eso aguanta 100 clicks.
        Ahora el guard es solo de CONCURRENCIA —no disparar dos peticiones a
        la vez— y se suelta en cuanto la peticion termina, no cuando termina
        la animacion.

     2. LA ANIMACION NO REARRANCABA. Si `is-added` ya estaba puesta,
        `classList.add` no hace nada y las animaciones CSS no se reinician:
        el segundo click no mostraba el check aunque el add funcionara. Se
        arregla quitando la clase, forzando un reflow y volviendola a poner.

     3. LOS TIMEOUTS SE APILABAN. Cada click programaba un setTimeout nuevo
        sin cancelar el anterior, asi que un reloj viejo podia arrancar la
        clase en mitad de la animacion del click nuevo. El prototipo hace
        clearTimeout antes de reprogramar; ahora esto tambien.

     Lo que NO se toca: el feedback sigue entrando SOLO con la respuesta OK
     de /cart/add.js (MIGRATION 8.1). Ese es el motivo real del retardo
     inicial y es deliberado: el prototipo no tiene red, la tienda si. Antes
     que mentir con un check que quiza falle, se espera la confirmacion.
     -------------------------------------------------- */
  function marcarAgregado(boton) {
    boton.classList.remove('is-added');
    void boton.offsetWidth;              /* reflow: reinicia las animaciones */
    boton.classList.add('is-added');
    if (boton._tioReloj) clearTimeout(boton._tioReloj);
    boton._tioReloj = setTimeout(function () {
      boton.classList.remove('is-added');
      boton._tioReloj = 0;
    }, 1600);
  }

  function agregar(boton, cerrarDespues) {
    if (!estado.variantId) return;
    if (boton._tioEnviando) return;      /* solo evita peticiones simultaneas */
    boton._tioEnviando = true;

    /* FEEDBACK INMEDIATO — decision del dueno, 28-jul-2026:
       "quiero velocidad y fluidez, quiero EXACTAMENTE LO MISMO que el diseno
       original que estamos migrando".

       El prototipo marca el boton ANTES de disparar el add:
           setAdded(true); clearTimeout(t.current); ...; onAdd(el)
       (pdp-frame.html:290). Se siente instantaneo porque no espera a nadie.

       Antes aca el check esperaba la respuesta de /cart/add.js — ~650 ms
       medidos en esta tienda— y el dueno lo leia como que el boton no
       respondia.

       Por que ahora es seguro adelantarlo: una variante AGOTADA no llega a
       este punto. Nace deshabilitada (P0.1: `.is-out`, sin pointer, nunca
       preseleccionada) y con el producto entero agotado el CTA sale
       `disabled`. El unico 422 que aparecio en pruebas fue por vaciar el
       stock a fuerza de clicks, no un caso de cliente.

       Lo que NO se adelanta y sigue viniendo del servidor: el CONTADOR del
       carrito y el vuelo, que salen del item_count real de /cart.js. El
       numero nunca miente. Y si el add falla, el .catch de mas abajo retira
       el check en vez de dejarlo puesto. */
    marcarAgregado(boton);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(estado.variantId), quantity: estado.qty }] })
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'No se pudo agregar'); });
        return r.json();
      })
      .then(function () {
        /* (2) El check ya se mostro al hacer click. Aca solo queda lo que
           DEBE salir del servidor: el contador real y el vuelo. */
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (carrito) {
            /* (3) El vuelo es decoracion y va con guard. */
            var safe = window.teFlySafe || function (el, onLand) { if (onLand) onLand(); };
            safe(boton, function () {
              if (typeof window.tioActualizarCarrito === 'function') {
                window.tioActualizarCarrito(carrito.item_count);
              }
              document.dispatchEvent(new CustomEvent('tio:cart:updated', { detail: carrito }));
            });
            if (cerrarDespues) setTimeout(cerrarSheet, 950);
          });
      })
      .catch(function (err) {
        /* El add fallo: se RETIRA el check que ya se habia mostrado, para no
           dejar al cliente creyendo que agrego algo que no entro. */
        if (boton._tioReloj) clearTimeout(boton._tioReloj);
        boton.classList.remove('is-added');
        console.error('[tio-pdp]', err);
      })
      .finally(function () {
        /* Se suelta al TERMINAR LA PETICION, no al terminar la animacion:
           el boton vuelve a estar disponible de inmediato. Quien apaga el
           check es el reloj de marcarAgregado(), que es independiente. */
        boton._tioEnviando = false;
      });
  }

  /* El form real se intercepta; si el JS falla, envia solo y funciona. */
  var form = $('[data-tio-pdp-form]');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var boton = $('[data-tio-pdp-add]', form);
      if (boton && !boton.disabled) agregar(boton, false);
    });
  }

  /* ------------------------------------------------------------
     Acordeon "Sobre la fragancia".

     Port de <Accordion> (pdp-frame.html:331). En el prototipo el estado es
     `useState(0)`: EXCLUSIVO —solo uno abierto a la vez— y el primero abierto
     al montar. Aca el primero ya nace con .is-open desde Liquid, asi que sin
     JS igual se ve uno abierto; esto solo agrega poder cambiarlo.

     Ojo: es exclusivo, al reves que la FAQ, donde el diseno pide cajones
     INDEPENDIENTES. Son piezas distintas y cada una sigue a su frame.

     UN listener delegado (§8.1). Toda la animacion es CSS via .is-open
     (max-height 0->360px, el icono rota 180°): aca no se mide ni se anima
     nada.
     ------------------------------------------------------------ */
  document.addEventListener('click', function (ev) {
    var cabeza = ev.target.closest('.acc-head');
    if (!cabeza) return;
    var grupo = cabeza.closest('[data-pdp-acc]');
    if (!grupo) return;

    var caja = cabeza.closest('.acc');
    var abrir = !caja.classList.contains('is-open');

    /* Exclusivo: se cierran todos y despues se abre el pulsado, si tocaba. */
    var todas = grupo.querySelectorAll('.acc');
    for (var i = 0; i < todas.length; i++) {
      todas[i].classList.remove('is-open');
      var b = todas[i].querySelector('.acc-head');
      if (b) b.setAttribute('aria-expanded', 'false');
    }
    if (abrir) {
      caja.classList.add('is-open');
      cabeza.setAttribute('aria-expanded', 'true');
    }
  });

  /* ------------------------------------------------------------
     Modal de NOTAS OLFATIVAS (la piramide del aroma).

     Port de pdp-frame.html:497-503 (disparador) y 576-590 (modal). En el
     prototipo es `notesOpen` de React; aca es la clase .is-active sobre
     .nm-overlay, que es la que consulta el CSS congelado.

     Toda la animacion es CSS: overlay con fade + blur, y el modal sube con
     spring en desktop (translateY(26px) scale(0.96) -> 0) o entra como hoja
     inferior en movil (translateY(100%) -> 0). La linea de tiempo se dibuja
     sola al montarse: nodos, tarjetas y el relleno de la linea son keyframes
     escalonados por --tl-delay. Aca no se anima ni se mide nada.

     Cierra con la X, con click fuera del modal y con Escape, igual que el
     resto de los overlays del tema. El bloqueo de scroll del body replica el
     de tio-quickview.js para no quedar con dos comportamientos distintos.
     ------------------------------------------------------------ */
  (function () {
    var overlay = document.querySelector('[data-pdp-notas]');
    if (!overlay) return;
    var disparador = document.querySelector('[data-pdp-notas-abrir]');

    function abrir(si) {
      overlay.classList.toggle('is-active', si);
      overlay.setAttribute('aria-hidden', si ? 'false' : 'true');
      document.body.style.overflow = si ? 'hidden' : '';
      if (disparador) {
        disparador.setAttribute('aria-expanded', si ? 'true' : 'false');
        disparador.classList.toggle('is-open', si);
        /* Al cerrar, el foco vuelve al boton que abrio: si se queda en un
           elemento que acaba de ocultarse, el lector de pantalla se pierde. */
        if (!si) disparador.focus();
      }
    }

    document.addEventListener('click', function (ev) {
      if (ev.target.closest('[data-pdp-notas-abrir]')) { abrir(true); return; }
      if (ev.target.closest('[data-pdp-notas-cerrar]')) { abrir(false); return; }
      /* Click fuera: el overlay es el fondo; el modal detiene la propagacion
         por posicion, asi que basta con comprobar que el click fue en el. */
      if (ev.target === overlay) abrir(false);
    });

    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && overlay.classList.contains('is-active')) abrir(false);
    });
  })();

  /* ============================================================
     CARRUSEL "¿ME SIRVE?" — portado 1:1 del componente ForWho del
     frame (diseno/previews/pdp-frame.html:846-912).

     El CSS de .fw-* ya estaba portado entero desde el primer dia; lo que
     faltaba era el markup y esta logica. Las medidas NO se inventan:
       - ancho de card = min(84% del track, 340px)   [frame:871]
       - padding lateral = (ancho del track - card) / 2, para centrar
       - reposo tras soltar el scroll = 150 ms       [frame:868]
       - animacion de centrado = 480 ms, ease-out cubico  [frame:866,599]

     ANTIFLASH (C4 §7): el servidor ya marco la primera card y el primer
     dot como .is-active y deshabilito la flecha previa. Aca solo se toma
     el relevo. Sin JS el track sigue siendo scrollable a mano.
     ============================================================ */
  (function () {
    var carrusel = $('[data-tio-fw]');
    if (!carrusel) return;

    var pista = $('[data-tio-fw-track]', carrusel);
    if (!pista) return;

    var cards = $$('.fw-card', pista);
    if (cards.length < 2) return;      /* con una sola card no hay que mover nada */

    var dots = $$('[data-tio-fw-dot]', carrusel);
    var flechaPrev = $('[data-tio-fw-prev]', carrusel);
    var flechaNext = $('[data-tio-fw-next]', carrusel);
    var activa = 0;

    /* Scroll suave propio: el nativo no permite fijar la duracion y el
       frame usa 480 ms con ease-out cubico. [frame:595-607] */
    function scrollSuave(el, destino, duracion) {
      var inicio = el.scrollLeft;
      var dist = destino - inicio;
      if (Math.abs(dist) < 1) return;
      /* El !important de tio-tokens.css apaga las animaciones CSS, pero esta
         corre en JS y se le escapaba: con reduced-motion se salta al destino.
         Mismo criterio que tio-fly.js, tio-header.js y el preloader. */
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.scrollLeft = destino;
        return;
      }
      var t0 = performance.now();
      if (el._tioAnim) cancelAnimationFrame(el._tioAnim);
      function paso(ahora) {
        var p = Math.min(1, (ahora - t0) / duracion);
        el.scrollLeft = inicio + dist * (1 - Math.pow(1 - p, 3));
        el._tioAnim = p < 1 ? requestAnimationFrame(paso) : 0;
      }
      el._tioAnim = requestAnimationFrame(paso);
    }

    /* scrollLeft que deja centrada la card j. */
    function centroDe(j) {
      var i = Math.max(0, Math.min(cards.length - 1, j));
      var rp = pista.getBoundingClientRect();
      var rc = cards[i].getBoundingClientRect();
      return pista.scrollLeft + (rc.left + rc.width / 2) - (rp.left + rp.width / 2);
    }

    /* Card cuyo centro esta mas cerca del centro del track. */
    function masCercana() {
      var medio = pista.getBoundingClientRect().left + pista.clientWidth / 2;
      var mejor = 0;
      var minDist = Infinity;
      for (var i = 0; i < cards.length; i++) {
        var r = cards[i].getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - medio);
        if (d < minDist) { minDist = d; mejor = i; }
      }
      return mejor;
    }

    function marcar(i) {
      if (i === activa) return;
      activa = i;
      for (var c = 0; c < cards.length; c++) cards[c].classList.toggle('is-active', c === i);
      for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-active', d === i);
      if (flechaPrev) flechaPrev.disabled = i === 0;
      if (flechaNext) flechaNext.disabled = i === cards.length - 1;
    }

    /* Al navegar con flecha o dot ya SABEMOS a que card vamos: se marca en
       el acto y el scroll solo la acompaña. Esperar al evento 'scroll' para
       pintar el estado deja el dot retrasado medio segundo — el mismo error
       que se corrigio en el boton de agregar. El listener de scroll sigue
       existiendo para el arrastre y el swipe, donde el destino no se sabe. */
    function irA(i, marcarYa) {
      var destino = Math.max(0, Math.min(cards.length - 1, i));
      if (marcarYa) marcar(destino);
      scrollSuave(pista, Math.max(0, centroDe(destino)), 480);
    }

    /* Ancho de card y padding de centrado, recalculados en cada resize. */
    function medir() {
      var ancho = Math.min(Math.round(pista.clientWidth * 0.84), 340);
      var lado = Math.max(0, Math.round((pista.clientWidth - ancho) / 2));
      pista.style.paddingLeft = lado + 'px';
      pista.style.paddingRight = lado + 'px';
      for (var i = 0; i < cards.length; i++) {
        cards[i].style.flex = '0 0 ' + ancho + 'px';
        cards[i].style.maxWidth = ancho + 'px';
      }
    }

    /* Arrastre con mouse. En tactil manda el scroll nativo. */
    var arrastre = { abajo: false, x: 0, desde: 0 };

    var pintando = 0;
    var reposo = 0;
    pista.addEventListener('scroll', function () {
      cancelAnimationFrame(pintando);
      pintando = requestAnimationFrame(function () { marcar(masCercana()); });
      clearTimeout(reposo);
      reposo = setTimeout(function () {
        /* No se reencuadra mientras el dedo/mouse sigue abajo ni durante
           una animacion nuestra: seria pelear contra el usuario. */
        if (arrastre.abajo || pista._tioAnim) return;
        irA(masCercana());
      }, 150);
    }, { passive: true });

    pista.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      ev.preventDefault();
      if (pista._tioAnim) { cancelAnimationFrame(pista._tioAnim); pista._tioAnim = 0; }
      arrastre.abajo = true;
      arrastre.x = ev.clientX;
      arrastre.desde = pista.scrollLeft;
      if (pista.setPointerCapture) pista.setPointerCapture(ev.pointerId);
    });
    pista.addEventListener('pointermove', function (ev) {
      if (!arrastre.abajo) return;
      pista.scrollLeft = arrastre.desde - (ev.clientX - arrastre.x);
    });
    function soltar() {
      if (!arrastre.abajo) return;
      arrastre.abajo = false;
      irA(masCercana());
    }
    pista.addEventListener('pointerup', soltar);
    pista.addEventListener('pointerleave', soltar);

    if (flechaPrev) flechaPrev.addEventListener('click', function () { irA(activa - 1, true); });
    if (flechaNext) flechaNext.addEventListener('click', function () { irA(activa + 1, true); });
    for (var d = 0; d < dots.length; d++) {
      dots[d].addEventListener('click', function (ev) {
        irA(Number(ev.currentTarget.getAttribute('data-tio-fw-dot')) || 0, true);
      });
    }

    medir();
    /* Segunda medida tras la maquetacion inicial: si una fuente o una
       imagen cambia el ancho del track, el centrado se corrige. [frame:878] */
    setTimeout(medir, 80);
    window.addEventListener('resize', medir);
  })();

  /* Entrada escalonada: sin JS nada queda en opacity:0 (anti-flash C4). */
  raiz.setAttribute('data-anim', '1');
  pintar();
})();
